// extracted by mini-css-extract-plugin
export default {"pageHeading":"pageHeading_pageHeading__dKFId","additionalInfo":"pageHeading_additionalInfo__2I1Bv"};